import type { AppShellBanner } from "../../../../../../shared/frontend/layout/AppShell";
import { useAuth } from "../auth/useAuth";
import { formatDateDisplay } from "../units/format";
import { useEffectiveUnits } from "../units/useEffectiveUnits";
import { useTenantDeletionActions, useTenantDeletionState } from "./useTenantDeletion";

/**
 * Roter Hinweis für Firmenadministratoren, solange eine Mandantenlöschung beantragt ist.
 * Sie können direkt aus dem Hinweis widerrufen.
 */
export function useTenantDeletionBanner(tr: (key: string) => string): AppShellBanner | undefined {
  const auth = useAuth();
  const units = useEffectiveUnits();
  // Plattform-Admins arbeiten im Admin-Mandanten; der Hinweis betrifft nur Mandantennutzer.
  const { data } = useTenantDeletionState(Boolean(auth.info) && !auth.hasRole("PlatformAdmin"));
  const { revoke } = useTenantDeletionActions();

  const request = data?.request;
  if (!data?.canManage || !request) return undefined;

  if (request.status !== "Pending") {
    return { type: "error", message: tr("The tenant is being deleted.") };
  }

  return {
    type: "error",
    message: tr("Tenant will be deleted on {date}").replace("{date}", formatDateDisplay(request.effectiveAt, units)),
    description: tr("All data and documents will then be permanently deleted."),
    action: data.canManage
      ? { label: tr("Deletion revoke"), onClick: () => revoke.mutate(), disabled: revoke.isPending }
      : undefined,
  };
}
